export class ErrorMessageModel {
    constructor(public headerMessage: string, public bodyMessage: string) {}
}
